module.exports = __webpack_public_path__ + "img/9791158886134.f061fe5c.jpg";